import React, { useContext, useEffect, useState } from "react";

import AvailableShots from "./available-shots";
import GroupShots from "./group-shots";
import * as notify from "shared/notify";
import authContext from "contexts/auth/authContext";

import { Select } from "../../form-inputs/inputs";
import { buildImageViewSelect, buildPackageTypeOptions } from "../lib/photoData";
import { PhotographyContext } from "../../../contexts/photography";
import { ShotContext } from "../context/index";
import { TASK_PERMISSIONS } from "shared/constants";
import { DEFAULT_LOCALE } from "../lib/helpers";
import { TaskContext } from "../../../contexts/task";

const ShotSelector = ({ disabled, isROPackageType, costcoFeatureName, productNameAttribute }) => {
    const { isAllowedPermission } = useContext(authContext);
    const { task } = useContext(TaskContext);
    const { lookups } = useContext(PhotographyContext);
    const { addMultiplePlaceholders, addSinglePlaceholder, packageTemplate, selectedLocale, shotsByLocale, updatePackageType } =
        useContext(ShotContext);
    const hasPermission = isAllowedPermission(TASK_PERMISSIONS.selectPhotographyPackageType);
    const [state, setState] = useState({
        regularShots: [],
        premiumShots: [],
        packageTypeOptions: [],
    });

    // FUTURE: Perhaps we remove this and allow multiple shots codes per locale Ex: (Montage)
    const usedShots =
        selectedLocale && shotsByLocale[selectedLocale.value]
            ? shotsByLocale[selectedLocale.value].map((s) => {
                  return s.imageViewCode;
              })
            : [];

    useEffect(() => {
        const premiumShots = buildImageViewSelect(lookups.imageViews, true);
        const regularShots = buildImageViewSelect(lookups.imageViews, false);
        const packageTypeOptions = buildPackageTypeOptions(lookups.newPackageTypes);

        setState({
            premiumShots,
            regularShots,
            packageTypeOptions,
        });
    }, [lookups.imageViews, lookups.groups, lookups.newPackageTypes]);

    const changePackageType = async (name, value) => {
        if (!hasPermission) {
            return notify.error("You do not have permission to perform this action.");
        }

        updatePackageType(value);
    };

    const isDefaultLocale = selectedLocale.value === DEFAULT_LOCALE.value;

    return (
        <div>
            {costcoFeatureName && <h4 className="m-t-12">Supplier Provided Product Name: {productNameAttribute}</h4>}
            {task.context.internalSupplierId && <h4 className="m-t-12">Internal Supplier ID: {task.context.internalSupplierId}</h4>}
            <Select
                required
                label="Package Type"
                name="packageType"
                value={packageTemplate.selectedId}
                groups={state.packageTypeOptions}
                updateOnChange={changePackageType}
                disabled={disabled || !isDefaultLocale || isROPackageType}
            />

            <GroupShots
                label="Shot Groups"
                groupShots={lookups.groups}
                addPlaceholders={addMultiplePlaceholders}
                disabled={disabled}
                isPremium={false}
                usedShots={usedShots}
            />

            <br />

            <AvailableShots
                label="Add Regular Shot"
                imageViews={state.regularShots}
                usedShots={usedShots}
                addPlaceholder={addSinglePlaceholder}
                disabled={disabled}
                isPremium={false}
            />
            <AvailableShots
                label="Add Premium Shot"
                imageViews={state.premiumShots}
                usedShots={usedShots}
                addPlaceholder={addSinglePlaceholder}
                disabled={disabled}
                isPremium={true}
            />
        </div>
    );
};

export default ShotSelector;
